import { type Employee, EmployeeSchema } from '../model/schema'

export interface EmployeeDto {
  id: string
  username: string
  name: string
  email: string
  departments?: string[]
  role: string
  is_admin: boolean
  is_active: boolean
}

export function toEmployee(dto: EmployeeDto): Employee {
  return EmployeeSchema.parse({
    id: dto.id,
    username: dto.username,
    name: dto.name,
    email: dto.email,
    departments: dto.departments ?? [],
    role: dto.role,
    isAdmin: dto.is_admin,
    isActive: dto.is_active,
  })
}
